import React from "react";

const QuranSettingsOverlay = ({
  isOpen,
  uiLanguage,
  uiLabels,
  uiTheme,
  verseFontScale,
  onClose,
  onChangeTheme,
  onChangeLanguage,
  onChangeVerseFontScale,
}) => {
  if (!isOpen) {
    return null;
  }

  const isArabic = uiLanguage === "ar";

  return (
    <div
      className="quran-settings-overlay"
      dir={isArabic ? "rtl" : "ltr"}
      onClick={onClose}
      onPointerUp={(event) => event.stopPropagation()}
    >
      <div
        className="quran-settings-panel"
        onClick={(event) => event.stopPropagation()}
        onPointerUp={(event) => event.stopPropagation()}
      >
        <div className={`quran-settings-head ${isArabic ? "quran-overlay-head--rtl" : "quran-overlay-head--ltr"}`}>
          <div className="quran-settings-title">{uiLabels.settings}</div>
          <button
            type="button"
            className="quran-overlay-close-btn quran-settings-close"
            onClick={onClose}
          >
            {uiLabels.close}
          </button>
        </div>

        <div className="quran-settings-section">
          <div className="quran-settings-section-title">{uiLabels.display}</div>
          <div className="quran-settings-field-label">{uiLabels.theme}</div>
          <div className="quran-settings-options">
            <label className="quran-settings-option">
              <input
                type="radio"
                name="quran-theme"
                checked={uiTheme === "light"}
                onChange={() => onChangeTheme("light")}
              />
              <span>{uiLabels.light}</span>
            </label>
            <label className="quran-settings-option">
              <input
                type="radio"
                name="quran-theme"
                checked={uiTheme === "dark"}
                onChange={() => onChangeTheme("dark")}
              />
              <span>{uiLabels.dark}</span>
            </label>
          </div>
        </div>

        <div className="quran-settings-section">
          <div className="quran-settings-field-label">{uiLabels.language}</div>
          <div className="quran-settings-options">
            <label className="quran-settings-option">
              <input
                type="radio"
                name="quran-language"
                checked={uiLanguage === "ar"}
                onChange={() => onChangeLanguage("ar")}
              />
              <span>العربية</span>
            </label>
            <label className="quran-settings-option">
              <input
                type="radio"
                name="quran-language"
                checked={uiLanguage === "fr"}
                onChange={() => onChangeLanguage("fr")}
              />
              <span>Francais</span>
            </label>
            <label className="quran-settings-option">
              <input
                type="radio"
                name="quran-language"
                checked={uiLanguage === "en"}
                onChange={() => onChangeLanguage("en")}
              />
              <span>English</span>
            </label>
          </div>
        </div>

        <div className="quran-settings-section">
          <div className="quran-settings-field-label">{uiLabels.verseFontSize}</div>
          <div className="quran-settings-slider-wrap">
            <button
              type="button"
              className="quran-overlay-close-btn quran-settings-step"
              onClick={() => onChangeVerseFontScale(Math.max(0.8, Number(verseFontScale || 1) - 0.05))}
            >
              -
            </button>
            <input
              className="quran-settings-slider"
              type="range"
              min={0.8}
              max={1.35}
              step={0.05}
              value={Number(verseFontScale || 1)}
              onChange={(event) => onChangeVerseFontScale(Number(event.target.value) || 1)}
              aria-label={uiLabels.verseFontSize}
            />
            <button
              type="button"
              className="quran-overlay-close-btn quran-settings-step"
              onClick={() => onChangeVerseFontScale(Math.min(1.35, Number(verseFontScale || 1) + 0.05))}
            >
              +
            </button>
            <span className="quran-settings-slider-value">{Math.round(Number(verseFontScale || 1) * 100)}%</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuranSettingsOverlay;
